import React from 'react';

const POINT_KEYS = ['point1', 'point2', 'point3'];

const WhatWeDoSection = ({ t }) => (
  <section className="py-12 bg-white curtain-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10 scroll-reveal">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
          <span className="text-gray-400">⚙️</span> {t.whatWeDo.title}{' '}
          <span className="text-gradient">{t.whatWeDo.titleHighlight}</span>
          {t.whatWeDo.titleEnd}
        </h2>
      </div>

      <div className="max-w-3xl mx-auto mb-10 space-y-4 text-center scroll-reveal">
        {t.whatWeDo.intro1 && (
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">{t.whatWeDo.intro1}</p>
        )}
        {t.whatWeDo.intro2 && (
          <p className="text-lg md:text-xl text-gray-900 font-semibold">{t.whatWeDo.intro2}</p>
        )}
        {t.whatWeDo.intro3 && (
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">{t.whatWeDo.intro3}</p>
        )}
        {t.whatWeDo.problem && (
          <p className="text-lg md:text-xl text-gray-600 italic">{t.whatWeDo.problem}</p>
        )}
      </div>

      <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-8 md:p-12 mb-8 text-center scroll-reveal-scale shadow-xl">
        <p className="text-xl md:text-2xl text-blue-50 mb-4 leading-relaxed">{t.whatWeDo.solution}</p>
        <p className="text-2xl md:text-3xl text-white font-bold">{t.whatWeDo.solutionBold}</p>
      </div>

      <div className="bg-blue-50 rounded-2xl p-8 md:p-12 mb-8 scroll-reveal-scale">
        <p className="text-xl text-gray-800 mb-6 font-medium text-center">{t.whatWeDo.subtitle}</p>
        <div className="grid md:grid-cols-3 gap-6 mb-2 stagger-list">
          {POINT_KEYS.map((key) => (
            <div key={key} className="bg-white p-6 rounded-xl shadow-sm text-center enhanced-card hover-lift">
              <div className="text-blue-600 text-3xl mb-3 animate-pulse-custom">✓</div>
              <p className="text-gray-900 font-semibold">{t.whatWeDo[key]}</p>
            </div>
          ))}
        </div>
      </div>

      {t.whatWeDo.result && (
        <div className="bg-green-50 border-l-4 border-green-500 p-6 md:p-8 rounded-lg scroll-reveal">
          <p className="text-lg md:text-xl text-green-800 font-semibold text-center">{t.whatWeDo.result}</p>
        </div>
      )}
    </div>
  </section>
);

export default WhatWeDoSection;
